import styled from 'styled-components';
import { Drawer as AntDesignDrawer } from 'antd';

export const Drawer = styled(AntDesignDrawer).attrs(() => ({
  bodyStyle: { padding: 0 },
}))``;
